import { Stack, styled } from '@mui/material';

export const SectionsWrapper = styled('article')(() => ({
  overflowY: 'auto',
}));

export const Wrapper = styled(Stack)(() => ({
  height: '100%',
}));
